import { makeStyles, Grid } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import SWLink from '../_components/SWLink'
import ContentFeature from '../_components/ContentFeature'

const useStyles = makeStyles<Theme, DesignerColorCollectionProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'DesignerColorCollection' }
)

export interface DesignerColorCollectionProps {
  classes?: StyleClasses<typeof useStyles>
}

function DesignerColorCollection(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ContentFeature
        title={
          <>
            Designer Color <br />
            Collection
          </>
        }
        description={
          <>
            Immerse yourself in our finest hues, featuring our brightest, purest whites and exquisite, designer-favorite
            colors. Available in select products.
          </>
        }
        cta={
          <Grid item xs={12}>
            <SWLink
              href="https://www.sherwin-williams.com/en-us/color/color-collections/designer-color-collection?utm_medium=referral&utm_source=paintscout&utm_campaign=digall-2026&utm_content=designer-color-collection"
              label="EXPLORE OUR COLLECTION"
              theme="dark"
              style={{ width: '100%' }}
            />
          </Grid>
        }
        colorTileA={{
          color: '#F4F4F2',
          colorCode: '9500',
          colorName: 'Ultra White',
          darkText: true
        }}
        colorTileB={{
          color: '#D2D5D5',
          colorCode: '79621',
          colorName: 'Clean Slate',
          darkText: true
        }}
        image={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/designer-color-collection.png'}
        imageAlt="Sherwin-Williams designer color collection"
      />
    </div>
  )
}

export default DesignerColorCollection
